import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import '../../../teacherTests.css';
import '../../../../../diagnosticReporting/DiagnosticStyles.css'
import React, {useContext, useRef, useState, useEffect, useMemo} from "react";
import {
    DatePicker,
    Form,
    Space,
    Table,
    TimePicker
} from "antd";
import Card from "@common/Card";
import {BrandContext} from "@context/BrandContext";

import Button from "@common/Button";
import TextArea from "@common/TextArea";
import dayjs from 'dayjs';
import {CheckCircleOutline, ErrorOutline, ExpandLess, ExpandMore} from "@mui/icons-material";
import {EditableCell, EditableRow} from "../../TestGroups/EditableTable";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Checkbox from "@common/Checkbox";
import {STEP_NUMBERS} from "../Data"
import StudentSkillResourceTable from "./StudentSkillResourceTable";
import axios from "@common/axios";
import Tooltip from "@common/Tooltip";
import HelpIcon from "@mui/icons-material/Help";
import {GRID_ENUMS} from "../../../../../diagnosticReporting/Styles.js";
import {UserContext} from "@context/UserContext";
import PopConfirm from "@common/PopConfirm";
import {ArrowLeftIcon} from "@common/icons";

const SkillResourceSelect = (props) => {
    const {stepChange, testAssignmentData, studentSkillResourceIdsMap, students, studentSkillScores, selectedTestAssignmentSkillResourceDisabledMap} = props;
    // console.log('studentSkillResourceIdsMap: ',studentSkillResourceIdsMap);
    // console.log('studentSkillScores: ',studentSkillScores);

    const [classAssignForm] = Form.useForm(),
        [studentData, setStudentData] = useState([]),
        [skillResourceData, setSkillResourceData] = useState([]),
        [selectedRows, setSelectedRows] = useState([]),
        [studentResultsMap, setStudentResultsMap] = useState({}),
        [isTableLoading, setIsTableLoading] = useState(true),
        [expandedRowKeys,setExpandedRowKeys] = useState([]),
        [selectedSkillResources,setSelectedResources] = useState();

    const
        // students = [{name:'Sokka Water Tribe', id:1}, {name:'Katara Water', id:2}, {name:'Aang Air', id:3}, {name:'Zuko Fire', id:4}, {name:'Azula Fire', id:5}, {name:'Toph Earth', id:6}, {name:'Bumi Earth', id:7}],
        brandConfig = useContext(BrandContext),
        skillResourceSelectTableRef = useRef(),
        rowHeight = 30;

    const {user, setUser} = useContext(UserContext);

    const RESOURCE_TYPE = {
        VIDEO:'video',
        SECTION:'section',
        WALKTHROUGH:'walkthrough',
        EXERCISE:'exercise'
    }

    const studentColumns = {
            Student:{title:'Student', key:'student', dataIndex:'student'},
            Performance:{title:'Performance on test', key:'performance', dataIndex:'performance',
                render: (value) => {
                    return <div className="ch-center-elem">{value}</div>;
                }},
            Work:{title: (
                    <span>{brandConfig.diagnosticFeedbackName}<Tooltip
                        title={(
                            <div><p>Select the {brandConfig.diagnosticFeedbackName.toLowerCase()} you would like students to complete.</p>
                                <p>{brandConfig.diagnosticFeedbackName} will be displayed to students as suggested revision.</p></div>
                        )}
                        placement="top"
                        arrowPointAtCenter>
                    <HelpIcon style={{
                        verticalAlign: 'middle',
                        marginLeft: '4px',
                        width: '16px',
                        height: '16px'
                    }}/>
                    </Tooltip></span>
                ), key:'followUp', dataIndex:'followUp',
                render: (value) => {
                    return <div>{value}</div>;
                }},
            Comment: {
                title: (<span>Comment to individual student (<i>optional</i> )</span>),
                key: 'comment',
                dataIndex: 'comment',
                render: (_, record) => {
                    return <div className="ch-center-elem">{record.hasComment ? <Tooltip placement={'top'} enterDelay={50} title={record.comment}
                                                                                         children={<CheckCircleIcon className={'ch-check-feedback-assigned'}/>}/> :
                        <CheckCircleOutline style={{fill: 'lightgrey'}}/>}</div>;
                }
            },
        },
        skillResourceColIndexes = {
            Skill:'skill',
            PercentCorrect:'percentCorrect',
            Section:RESOURCE_TYPE.SECTION,
            Video:RESOURCE_TYPE.VIDEO,
            Walkthrough:RESOURCE_TYPE.WALKTHROUGH,
            Exercise:RESOURCE_TYPE.EXERCISE
        }

    const studentColumnDefs = [];
    for(const [key,value] of Object.entries(studentColumns)){
        studentColumnDefs.push(value);
    }

    useEffect(()=>{
        getSkillResourceData();
        // setSkillResourceData(dummyData);
        setIsTableLoading(true);
    },[]);

    const CHECKBOX_TYPES = {
        CONCEPT:0,
        SKILL:1,
        RESOURCE_COLUMN:2,
        SINGLE_RESOURCE:3
    }

    const getSkillResourceData = ()=>{
        axios.get('/web/ui/test/getTestAssignmentConceptSkillResources',{params:{testAssignmentId:testAssignmentData.testAssignmentId}})
            .then((response)=>{
                // console.log('response.data: ',response.data);
                setSkillResourceData(response.data);
            }).catch((error)=>{
                displayToastMessage('Error getting skill resources.', '', 'error', 10000);
                console.error('Error getting skill resources: ',error);
            }).finally(() => {
                setIsTableLoading(false);
            });
    }

    const generateStudentData = (data)=>{

        // console.log('data: ',data);
        // console.log('studentSkillResourceIds : ',studentSkillResourceIds);
        // console.log('dummyStudents : ',dummyStudents);

        const skillResourceMapData = {};
        const dataForStudent = [];
        students.forEach((student)=>{
            let row = {name: student.name, key:String(student.userId), id: student.userId};
            const skills = [];
            let studentRowData = [];
            let skillResourcesChecked = 0;

            data.forEach((concept) => {
                // console.log('conceptKey: ',conceptKey);
                // console.log('conceptValue: ',conceptValue);
                let conceptRow = {titleHighlight:true, rowSpan:6, isConcept:true};
                conceptRow[skillResourceColIndexes.Skill] = {showCheckbox:true, textLink:concept.conceptName ,checked:false, checkboxType:CHECKBOX_TYPES.CONCEPT};
                // conceptRow[skillResourceColIndexes.PercentCorrect.dataIndex] = student.score+'%';
                // conceptRow[skillResourceColIndexes.PercentCorrect] = 'add later %';
                conceptRow[skillResourceColIndexes.Section] = {showCheckbox:false};
                conceptRow[skillResourceColIndexes.Video] = {showCheckbox:false};
                conceptRow[skillResourceColIndexes.Walkthrough] = {showCheckbox:false};
                conceptRow[skillResourceColIndexes.Exercise] = {showCheckbox:false};

                let setConcept = true;

                concept.reviewConcepts.forEach((reviewConcept) => {
                    // console.log('reviewConcept: ',reviewConcept);
                    if(setConcept){
                        conceptRow.conceptId = reviewConcept.conceptId;
                        conceptRow.key = reviewConcept.conceptId;
                        setConcept = false;
                    }
                    let skillResourceRow =
                        {
                            key:reviewConcept.conceptId+'-'+reviewConcept.skillId,
                            skillId:reviewConcept.skillId,
                            isSkill:true,
                            conceptId:reviewConcept.conceptId
                        };
                    if(studentSkillScores.hasOwnProperty(String(student.userId)) && studentSkillScores[student.userId].hasOwnProperty(String(reviewConcept.skillId))){
                        if (!studentRowData.includes(conceptRow)) {
                            studentRowData.push(conceptRow);
                        }

                        skillResourceRow[skillResourceColIndexes.PercentCorrect] = studentSkillScores[student.userId][reviewConcept.skillId]+'%';

                        reviewConcept.skillResources.forEach((skillResource)=>{
                            // console.log('skillResource: ',skillResource);
                            // console.log('studentSkillResourceIdsMap[student.userId]: ',studentSkillResourceIdsMap[student.userId]);
                            const skillResourceChecked = studentSkillResourceIdsMap[student.userId] ? studentSkillResourceIdsMap[student.userId].includes(skillResource.skillResourceId) : false;
                            const skillResourceObj = {
                                showCheckbox: true,
                                checked: skillResourceChecked,
                                checkboxType: CHECKBOX_TYPES.SINGLE_RESOURCE,
                                skillResourceId: skillResource.skillResourceId,
                                conceptId: skillResource.conceptId
                            };
                            if(skillResourceChecked){
                                skillResourcesChecked++;
                            }
                            if(skillResource.resourceType === 'CONCEPT'){
                                skillResourceObj.textLink = skillResource.textbookConceptName;
                                skillResourceRow[skillResourceColIndexes.Section] = skillResourceObj;
                            }else if(skillResource.resourceType === 'TUTORIAL' && skillResource.tutorialSubType === 'EXAMPLE'){
                                skillResourceObj.textLink = 'Example '+skillResource.resourceNumber;
                                skillResourceRow[skillResourceColIndexes.Video] = skillResourceObj;
                            }else if(skillResource.resourceType === 'QUESTION'){
                                if(skillResource.questionType === 'WALKTHROUGH'){
                                    skillResourceObj.textLink = 'Now You Try '+skillResource.resourceNumber;
                                    skillResourceRow[skillResourceColIndexes.Walkthrough] = skillResourceObj;
                                }
                            }else if(skillResource.resourceType === 'QUESTION_CLUSTER'){
                                skillResourceObj.textLink = skillResource.resourceNumber+': '+skillResource.resourceSubNumbers;
                                skillResourceRow[skillResourceColIndexes.Exercise] = skillResourceObj;
                            }

                            // // skillResourceRow[skillResourceColumns.PercentCorrect.dataIndex] = score+'%';
                            // // skillResourceRow[skillResourceColumns.PercentCorrect.dataIndex] = score+'%';

                            // let questionsNum = randomInt(1,6);
                            // skillResourceRow[skillResourceColumns.Exercise.dataIndex] = {showCheckbox:true, textLink:(questionsNum) +', ' + (questionsNum+1) + ', ' + (questionsNum+2) , checked:randomBoolean(),checkboxType:CHECKBOX_TYPES.SINGLE_RESOURCE};
                            // // skills.push(skill);
                        });
                        Object.values(skillResourceColIndexes).forEach((value)=>{
                            if(value !== skillResourceColIndexes.PercentCorrect && value !== skillResourceColIndexes.Skill && !skillResourceRow.hasOwnProperty(value)){
                                skillResourceRow[value] = {showCheckbox:false, textLink:'no '+value+'s'};
                            }
                        });

                        skillResourceRow[skillResourceColIndexes.Skill] = {showCheckbox:true, textLink:reviewConcept.skillName ,checked:false,checkboxType:CHECKBOX_TYPES.SINGLE_RESOURCE}
                        // console.log('skillResourceRow: ',skillResourceRow);
                        studentRowData.push(skillResourceRow);
                    }else{
                        skillResourceRow[skillResourceColIndexes.PercentCorrect] = GRID_ENUMS.NOT_AVAILABLE;
                    }
                });
            });

            const studentSkillResourceEntry = selectedTestAssignmentSkillResourceDisabledMap[student.userId];

            row.expandable = studentRowData.length > 0 && studentSkillResourceEntry === undefined;
            row[studentColumns.Student.dataIndex] = student.name;
            row.hasComment = false || (studentSkillResourceEntry !== undefined && studentSkillResourceEntry.feedbackMessage !== null);
            row.comment = studentSkillResourceEntry !== undefined && studentSkillResourceEntry.feedbackMessage !== null ? studentSkillResourceEntry.feedbackMessage : undefined
            row[studentColumns.Performance.dataIndex] = studentSkillScores[student.userId].testScore;
            // row[studentColumns.Comment.dataIndex] = 'Comment';
            row[studentColumns.Work.dataIndex] = (skillResourcesChecked > 0 ? skillResourcesChecked : (studentSkillResourceEntry !== undefined && studentSkillResourceEntry.skillResourceIds.length > 0) ? studentSkillResourceEntry.skillResourceIds.length : 'No') + ' skill resources selected';
            row.expanded = false;

            dataForStudent.push(row);
            skillResourceMapData[student.userId] = {studentData:studentRowData};
        });
        setStudentResultsMap(skillResourceMapData);
        return dataForStudent;
    }

    useEffect(()=>{
        if (skillResourceData.length > 0) {
            setStudentData(generateStudentData(skillResourceData));
        }
    },[skillResourceData]);

    const onResultExpand = (record)=>{
        setIsTableLoading(true);
        // console.log('record.key: ',record.key);
        if(record.expanded){
            collapseRow(record.id);
            record.expanded = false;
        }else{
            expandRow(record.id);
            record.expanded = true;
        }
        setIsTableLoading(false);
    }

    const expandRow = (studentId, testData) => {
        studentData.forEach((row) => {
            if (parseInt(row.id) === parseInt(studentId)) {
                row.expanded = true;
                if (!expandedRowKeys.includes(studentId)) {
                    setExpandedRowKeys([...expandedRowKeys, String(studentId)]);
                }
            }
        });
    }

    const collapseRow = (studentId) => {
        studentData.forEach((row) => {
            if (row.id === studentId) {
                row.expanded = false;
                setExpandedRowKeys(expandedRowKeys.filter((key) => key !== String(studentId)));
            }
        });
    }

    const backToResults = ()=>{
        stepChange(STEP_NUMBERS.SKILL_SELECT.number);
    }

    const assignFollowUpWork = async () => {
        const fieldValues = classAssignForm.getFieldsValue();

        if(!fieldValues.taskDueDate){
            classAssignForm.validateFields();
            return;
        }

        const classComment = fieldValues.classComment,
            taskDueDate = fieldValues.taskDueDate,
            studentCommentsMap = {};

        studentData.forEach((row)=>{
            // console.log('row: ',row);
            let comment;
            if(row.hasComment){
                comment = row.comment;
            }else{
                comment = '';
            }
            studentCommentsMap[row.key] = comment;
        })

        const studentIdsToSkillResourceIdsMapWithComments = {};
        for(const [key,value] of Object.entries(studentResultsMap)){
            const skillResourceIdList = [];
            value.studentData.forEach((row)=>{
                if(row.isSkill){
                    for(const [skillResourceKey,skillResourceValue] of Object.entries(row)){
                        if(skillResourceValue.checked){
                            skillResourceIdList.push(skillResourceValue.skillResourceId);
                        }
                    }
                }
            });

            if(skillResourceIdList.length > 0 ){
                studentIdsToSkillResourceIdsMapWithComments[key] = {
                    skillResourceIds: skillResourceIdList,
                    feedbackMessage: studentCommentsMap[key]
                };
            }
        }

        // console.log('studentIdsToSkillResourceIdsMapWithComments: ',studentIdsToSkillResourceIdsMapWithComments)

        await axios.post('/web/ui/test/createTestResultSkillResources', studentIdsToSkillResourceIdsMapWithComments,{
            params:{
                testAssignmentId: testAssignmentData.testAssignmentId,
                classComment: classComment,
                taskDueDate: taskDueDate
            }
        }).then((response)=>{
            displayToastMessage(brandConfig.diagnosticFeedbackName + ' assigned successfully', null, 'success', null, 10000);
            stepChange(STEP_NUMBERS.ASSIGNED_FOLLOW_UP_WORK.number);
        }).catch((error)=>{
            displayToastMessage('Error assigning ' + brandConfig.diagnosticFeedbackName, error, 'error',null, 10000);
            console.error('Error assigning follow up work: ', error);
        });
    }

    const handleSkillResourceChange = (record,data)=>{
        // console.log('record: ',record);
        // console.log('data: ',data);
        const updateStudentMap = {...studentResultsMap};
        updateStudentMap[record.key].studentData = data;
        // console.log('data: ',data);
        let resourceSkillsCount = 0;
        data.forEach((row)=>{
            if(row.isSkill){
                if(row[RESOURCE_TYPE.EXERCISE].checked){
                    resourceSkillsCount++;
                }
                if(row[RESOURCE_TYPE.VIDEO].checked){
                    resourceSkillsCount++;
                }
                if(row[RESOURCE_TYPE.SECTION].checked){
                    resourceSkillsCount++;
                }
                if(row[RESOURCE_TYPE.WALKTHROUGH].checked){
                    resourceSkillsCount++;
                }
            }
        });

        // console.log('resourceSkillsCount: ',resourceSkillsCount);
        const updateData = [];
        studentData.forEach((studentRow)=>{
           if(studentRow.key === record.key){
               studentRow.followUp = (resourceSkillsCount > 0 ? resourceSkillsCount : 'No')+' skill resources selected';
           }
            updateData.push(studentRow);
        });
        // console.log('updateData: ',updateData);
        setStudentData(updateData);
        setStudentResultsMap(updateStudentMap);
    }

    const handleStudentCommentChange = (record, comment) =>{
        // console.log('record: ',record);
        // console.log('comment: ',comment);
        const updateData = [];
        studentData.forEach((row)=>{
            if(row.key === record.key){
                row.hasComment = comment && comment !== '';
                row.comment = comment;
            }
            updateData.push(row);
        });
        // console.log('updateData: ',updateData);
        setStudentData(updateData);
    }

    return (
        <>
            <div>
                <Space className="flex" orientation="horizontal" size="middle" style={{width:'100%', margin:'12px 4px 6px 4px', justifyContent:'space-between'}}>
                    <h2>{brandConfig.diagnosticFeedbackName} summary ({testAssignmentData.testName})</h2>
                    <div className="flex" style={{gap: '12px', marginRight: '8px'}}>
                        <Button type="outline" onClick={backToResults}><ArrowLeftIcon/> Back to results</Button>
                        <PopConfirm
                            placement="left"
                            title={"Confirm your " + brandConfig.diagnosticFeedbackName.toLowerCase() + "?"}
                            description={"Confirm " + brandConfig.diagnosticFeedbackName.toLowerCase()}
                            onConfirm={assignFollowUpWork}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button>Assign</Button>
                        </PopConfirm>
                    </div>
                </Space>
                <Space orientation="vertical" size="middle" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Card id="studentResultSearchBox" rounded={false}>
                        <h4>Class-wide notifications</h4>
                        <Form
                            id="classAssignForm"
                            form={classAssignForm}
                            initialValues={{
                                classComment: testAssignmentData.feedbackMessage !== undefined ? testAssignmentData.feedbackMessage : '',
                                taskDueDate: dayjs().add(1, 'week').add(1, 'h').minute(0).second(0)
                            }}
                            layout="vertical"
                            style={{display:'flex', gap:'12px'}}
                        >
                        <div className={'flexColumn'} style={{width:'50%'}}>
                            <span>Comment (<i>optional</i> )<Tooltip
                                title={(
                                    <div><p>Messages written in the class comment box will be displayed as a comment alongside
                                        the {brandConfig.diagnosticFeedbackName.toLowerCase()} to the students listed below</p></div>
                                )}
                                placement="top"
                                arrowPointAtCenter>
                                    <HelpIcon style={{
                                        verticalAlign: 'middle',
                                        marginLeft: '4px',
                                        width: '16px',
                                        height: '16px'
                                    }}/>
                                </Tooltip></span>
                                <Form.Item
                                    name="classComment"
                                >
                                    <TextArea placeholder="Write a comment for your class" rows={4} />
                                </Form.Item>
                            </div>
                            <Form.Item
                                name="taskDueDate"
                                label="Task due date"
                                style={{width:'215px'}}
                                rules={[
                                    {
                                        required: true,
                                        validator: (_, value) => {
                                            if(!value){
                                                return Promise.reject('Please select a date.');
                                            }else if (dayjs(value).isAfter(dayjs())) {
                                                return Promise.resolve();
                                            } else {
                                                return Promise.reject('Please select a date in the future');
                                            }
                                        }
                                    },
                                ]}
                            >
                                <DatePicker
                                    showTime={{format: 'HH:mm'}}
                                    format={user.getDateTimeFormatString()}
                                    placement="topLeft"
                                />
                            </Form.Item>
                        </Form>
                    </Card>
                    <Card rounded={false} style={{minHeight:'1000px'}}>
                        <div className="flex padding-b--m" style={{justifyContent:'space-between'}}>
                            <Table id="skillResources" className="ch-general-table-antd"
                                   ref={skillResourceSelectTableRef}
                                   rowClassName={(record) => (record.expandable ? 'ch-expandable-row' : 'ch-non-expandable-row')}
                                   expandable={{
                                       expandedRowKeys: expandedRowKeys,
                                       expandRowByClick: true,
                                       rowExpandable: (record) => {return record.expandable},
                                       onExpand: (e, record) => {onResultExpand(record)},
                                       expandedRowRender: (record) => {
                                           // console.log('record: ',record);
                                           // console.log('studentResultsMap: ',studentResultsMap);
                                           return (<StudentSkillResourceTable
                                               studentRecord={record}
                                               handleSkillResourceChange={(data)=>{handleSkillResourceChange(record,data)}}
                                               handleStudentCommentChange={(comment)=>{handleStudentCommentChange(record,comment)}}
                                               dataSource={studentResultsMap.hasOwnProperty(record.key) ? studentResultsMap[record.key].studentData : []}
                                           />);
                                       },
                                       expandIcon: ({ expanded, record }) => {
                                           return (
                                               !record.expandable ? <></> :
                                                   expanded ? (
                                                       <ExpandLess style={{width: '24px', height: '24px', cursor: 'pointer'}} onClick={() => onResultExpand(record)}/>
                                                   ) : (
                                                       <ExpandMore style={{width: '24px', height: '24px', cursor: 'pointer'}} onClick={() => onResultExpand(record)}/>
                                                   )
                                           )
                                       }
                                   }}
                                   size={'middle'}
                                   columns={studentColumnDefs}
                                   dataSource={studentData}
                                   loading={isTableLoading}
                            />
                        </div>
                    </Card>
                </Space>
            </div>
        </>
    )
}
export default SkillResourceSelect;
